export class PylosFailure {
    static MUST_MOVE_UPWARD = () => $localize `You must move your pieces upward.`;
    static SHOULD_HAVE_SUPPORTING_PIECES = () => $localize `Your piece must land on the board or on 4 other pieces.`;
    static CANNOT_MOVE_SUPPORTING_PIECE = () => $localize `You cannot move a supporting piece.`;
    static CANNOT_CAPTURE = () => $localize `You cannot capture.`;
    static INVALID_FIRST_CAPTURE = () => $localize `Your first capture is invalid.`;
    static INVALID_SECOND_CAPTURE = () => $localize `Your second capture is invalid.`;
}
